import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ImageCroppedEvent } from 'ngx-image-cropper';

export interface DialogData {
    subTitle: string,
    description: string,
    label1: string,
    label2: string,
    label3: string,
    supportTextForlabel3: string,
    positiveAction: CallableFunction,
    negativeAction: CallableFunction,
    action?: boolean,
    parent: any,
    imageChanged: any,
}
@Component({
    selector: 'image-cropper-dialog',
    templateUrl: './image-cropper-dialog.component.html',
    styleUrls: ['../dialog-box.scss']
})
export class ImageCropperDialogComponent implements OnInit {
    set: boolean = false;
    subTitle: string = "The current task have issues";

    constructor(
        public dialogRef: MatDialogRef<ImageCropperDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData,
    ) { }

    ngOnInit(): void {
    }

    negativeAction() {
        this.dialogRef.close(false);
    }

    positiveAction() {
        this.dialogRef.close(this.convertCroppedImageToFile);
    }



    convertCroppedImageToFile;
    imageCropped(event: ImageCroppedEvent) {
        // this.croppedImage = event.base64;
        this.convertCroppedImageToFile = this.base64ToFile(event.base64, this.data.imageChanged.target.files[0].name,);
    }

    base64ToFile(data, fileName) {
        const arr = data.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        let u8arr = new Uint8Array(n);

        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }

        return new File([u8arr], fileName, { type: mime });
    }
}
